/**
 * MOQ (Minimum Order Quantity) Handler
 * Surcharge functionality has been removed per user request
 */


(function() {
  'use strict';

  /**
   * MOQ Validation Handler
   */
  class MOQHandler {
    constructor() {
      this.init();
    }

    init() {
      // Handle product page MOQ
      this.initProductPageMOQ();
      
      // Handle cart page MOQ
      this.initCartMOQ();
    }

    initProductPageMOQ() {
      const productForm = document.querySelector('[data-product-form]');
      if (!productForm) return;

      const moqNotice = productForm.querySelector('[data-product-moq]');
      if (!moqNotice) return;

      const moq = parseInt(moqNotice.getAttribute('data-product-moq'), 10);
      const quantityInput = productForm.querySelector('[data-quantity-input]');
      const quantitySelector = productForm.closest('form').querySelector('quantity-selector');
      
      if (!quantityInput || !moq) return;

      // Ensure quantity is at least MOQ
      const currentValue = parseInt(quantityInput.value, 10);
      if (currentValue < moq) {
        quantityInput.value = moq;
        this.updateQuantitySelector(quantitySelector, moq);
      }

      // Validate on form submit
      const form = productForm.closest('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          const quantity = parseInt(quantityInput.value, 10);
          if (quantity < moq) {
            e.preventDefault();
            e.stopPropagation();
            alert(`Minimum order quantity is ${moq}. Please increase your quantity.`);
            quantityInput.value = moq;
            this.updateQuantitySelector(quantitySelector, moq);
            quantityInput.focus();
            return false;
          }
        });
      }

      // Validate on input change
      quantityInput.addEventListener('change', () => {
        const quantity = parseInt(quantityInput.value, 10);
        if (quantity < moq) {
          quantityInput.value = moq;
          this.updateQuantitySelector(quantitySelector, moq);
        }
      });

      // Validate on blur
      quantityInput.addEventListener('blur', () => {
        const quantity = parseInt(quantityInput.value, 10);
        if (quantity < moq) {
          quantityInput.value = moq;
          this.updateQuantitySelector(quantitySelector, moq);
        }
      });
    }

    initCartMOQ() {
      // Find all cart items with MOQ
      const cartItems = document.querySelectorAll('[data-cartitem][data-item-moq]');
      
      // Prevent multiple initializations
      if (document.querySelector('[data-moq-cart-initialized]')) {
        return;
      }
      document.body.setAttribute('data-moq-cart-initialized', 'true');
      
      cartItems.forEach(cartItem => {
        const moq = parseInt(cartItem.getAttribute('data-item-moq'), 10);
        const quantityInput = cartItem.querySelector('[data-quantity-input]');
        const minusButton = cartItem.querySelector('[data-quantity-minus]');
        const minusButtonWrapper = cartItem.querySelector('[data-button-wrapper-minus]');
        
        if (!quantityInput || !moq || moq <= 1) return;

        // Set min attribute
        quantityInput.setAttribute('min', moq);

        // Flag to prevent infinite loops
        let isUpdating = false;
        let previousValue = parseInt(quantityInput.value, 10) || moq;

        // Disable minus button if at MOQ
        const updateMinusButtonState = () => {
          const currentQty = parseInt(quantityInput.value, 10);
          if (minusButtonWrapper) {
            if (currentQty <= moq) {
              minusButtonWrapper.classList.add('quantity-selector__button-wrapper--disabled');
              minusButton.setAttribute('disabled', 'disabled');
              minusButton.style.pointerEvents = 'none';
              minusButton.style.cursor = 'not-allowed';
            } else {
              minusButtonWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
              minusButton.removeAttribute('disabled');
              minusButton.style.pointerEvents = '';
              minusButton.style.cursor = '';
            }
          }
        };

        // Intercept minus button click BEFORE other handlers
        if (minusButton) {
          // Use capture phase to intercept before other handlers
          minusButton.addEventListener('click', (e) => {
            const currentQty = parseInt(quantityInput.value, 10);
            if (currentQty <= moq) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              alert(`Minimum order quantity for this item is ${moq}.`);
              updateMinusButtonState();
              return false;
            }
          }, true); // Use capture phase
        }

        // Prevent input changes below MOQ
        quantityInput.addEventListener('beforeinput', (e) => {
          if (isUpdating) return;
          
          const newValue = parseInt(e.data || quantityInput.value, 10);
          if (!isNaN(newValue) && newValue < moq) {
            e.preventDefault();
            return false;
          }
        });

        // Validate and correct on input
        quantityInput.addEventListener('input', (e) => {
          if (isUpdating) return;
          
          const newValue = parseInt(quantityInput.value, 10);
          if (isNaN(newValue) || newValue < moq) {
            e.preventDefault();
            quantityInput.value = previousValue;
            updateMinusButtonState();
            return false;
          }
          previousValue = newValue;
          updateMinusButtonState();
        });

        // Validate on change
        quantityInput.addEventListener('change', (e) => {
          if (isUpdating) return;
          
          const quantity = parseInt(quantityInput.value, 10);
          if (isNaN(quantity) || quantity < moq) {
            alert(`Minimum order quantity for this item is ${moq}. Quantity has been adjusted.`);
            isUpdating = true;
            quantityInput.value = moq;
            previousValue = moq;
            updateMinusButtonState();
            this.updateCartItemQuantity(cartItem, moq, false).then(() => {
              isUpdating = false;
            });
          } else {
            previousValue = quantity;
            updateMinusButtonState();
          }
        });

        // Validate on blur
        quantityInput.addEventListener('blur', () => {
          if (isUpdating) return;
          
          const quantity = parseInt(quantityInput.value, 10);
          if (isNaN(quantity) || quantity < moq) {
            quantityInput.value = moq;
            previousValue = moq;
            updateMinusButtonState();
          }
        });

        // Intercept keyboard events
        quantityInput.addEventListener('keydown', (e) => {
          if (isUpdating) return;
          
          const currentQty = parseInt(quantityInput.value, 10);
          
          // Prevent arrow down or minus key if at MOQ
          if ((e.key === 'ArrowDown' || e.key === '-' || e.key === 'Delete') && currentQty <= moq) {
            e.preventDefault();
            return false;
          }
        });

        // Initial state
        updateMinusButtonState();
        
        // Ensure initial quantity meets MOQ (without alert on page load)
        const currentQty = parseInt(quantityInput.value, 10);
        if (currentQty < moq) {
          isUpdating = true;
          quantityInput.value = moq;
          previousValue = moq;
          updateMinusButtonState();
          this.updateCartItemQuantity(cartItem, moq, false).then(() => {
            isUpdating = false;
          });
        }
      });
    }

    async updateCartItemQuantity(cartItem, quantity, reload = true) {
      const itemKey = cartItem.getAttribute('data-cartitem-key');
      if (!itemKey) return Promise.resolve();

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: quantity
          })
        });

        if (response.ok) {
          // Trigger cart update event
          window.dispatchEvent(new CustomEvent('cartcount:update'));
          
          // Only reload if explicitly requested (prevents infinite loops)
          if (reload) {
            // Use a small delay to prevent rapid reloads
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }
          
          return Promise.resolve();
        }
        return Promise.reject(new Error('Cart update failed'));
      } catch (error) {
        console.error('Error updating cart item quantity:', error);
        return Promise.reject(error);
      }
    }

    updateQuantitySelector(selector, value) {
      if (!selector) return;
      const input = selector.querySelector('[data-quantity-input]');
      if (input) {
        input.value = value;
        // Trigger change event to update any listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }


  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MOQHandler();
    });
  } else {
    new MOQHandler();
  }

  // Also initialize MOQ handler when product form is dynamically loaded
  document.addEventListener('DOMContentLoaded', () => {
    // Re-initialize MOQ handler for dynamically loaded content
    const observer = new MutationObserver(() => {
      const existingHandler = document.querySelector('[data-moq-handler-initialized]');
      if (!existingHandler) {
        new MOQHandler();
        document.querySelector('[data-product-form]')?.setAttribute('data-moq-handler-initialized', 'true');
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();
